<template>
  <section class="statistics-section" :class="{ 'statistics-section-mobile': isMobile }">
    <div class="transfer" id="transfer">
      <img src="../assets/images/transfer-bg.png" alt="" class="background-image" loading="lazy">
      <div class="content">
        <div class="title">
          {{ $t('transfer.title') }}
        </div>
        <div class="description">
          <p v-for="(line, index) in transfer.description" :key="index">
            {{ line }}
          </p>
        </div>
        <div class="cards" ref="animateSection">
          <div class="single-card left">
            <p>{{ $t('fromTivat') }}</p>

            Tivat {{ $t('city') }} – 25€ <br>
            Kotor – 40€<br>
            Budva – 50€<br>
            Petrovac – 65€<br>
            Sutomore – 80€<br>
            Bar – 90€<br>
            Ulcinj – 110€<br>
            Risan – 65€<br>
            Herceg Novi – 85€<br>
          </div>
          <div class="single-card right">
          <p>{{ $t('fromPodgorica') }}</p>

            Podgorica {{ $t('city') }} – 30€<br>
            Bar – 75€<br>
            Sutomore – 70€<br>
            Ulcinj – 100€<br>
            Petrovac – 65€<br>
            Budva – 65€<br>
            Kotor – 100€<br>
            Risan – 120€<br>
            Herceg Novi – 140€<br>
          </div>
        </div>
        <button class="btn" @click="openModal">{{ $t('bookTransfer') }}</button>
      </div>
    </div>
    <!-- Modal -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal" @click.stop>
        <button class="close-btn" @click="closeModal">&times;</button>
        <div v-if="!submitted">
          <h2>{{ $t('rentACar.form.reservation') }}</h2>
          <form @submit.prevent="sendEmail">

            <div class="row">
              <label for="name">{{ $t('rentACar.form.name') }}</label>
              <input type="text" id="name" v-model="formData.name" required/>
            </div>
            <div class="row">
              <label for="email">{{ $t('rentACar.form.email') }}</label>
              <input type="text" id="email" v-model="formData.contact" required/>
            </div>
            <div class="row">
              <label for="text">{{ $t('rentACar.form.text') }}</label>
              <textarea id="text" v-model="formData.message" rows="4"></textarea>
            </div>
            <button type="submit" class="submit-btn">{{ $t('rentACar.form.send') }}</button>
          </form>
        </div>
        <div v-else class="confirmation">
          <h2 v-if="!emailError">{{ $t('rentACar.form.reservationSuccess') }} </h2>
          <h2 v-else style="color: red;">{{ $t('rentACar.form.reservationFailed') }} </h2>

          <p v-if="!emailError" class="thank-you-msg">{{ $t('rentACar.form.success') }}</p>
          <p v-else class="thank-you-msg" style="color: red;">
            {{ $t('rentACar.form.tryAgain') }}
          </p>
          <br>
          <p v-if="!emailError"><strong>{{ $t('rentACar.form.name') }}:</strong> {{ formData.name }}</p>
          <p v-if="!emailError"><strong>{{ $t('rentACar.form.contact') }}:</strong> {{ formData.contact }}</p>
          <br>

        </div>
        <div v-if="isLoading" class="loader">
          <div class="spinner"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  name: 'TransferSection',
  data() {
    return {
      isMobile: false,
      showModal: false,
      submitted: false,
      emailError: false,
      isLoading: false,
      formData: {
        name: '',
        contact: '',
        date: 'Nema podataka o datumu',
        category: 'Transfer',
        message: ''
      },
    };
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.$refs.animateSection.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(this.$refs.animateSection);
  },
  computed: {
    transfer() {
      return this.$i18n.getLocaleMessage(this.$i18n.locale).transfer;
    },
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 1159
    },
    openModal() {
      this.showModal = true;
      this.submitted = false;
    },
    closeModal() {
      this.showModal = false;
      this.formData = {name: "", contact: "", message: ""};
    },
    sendEmail() {
      this.isLoading = true;
      this.formData.category = "Transfer"
      emailjs
          .send(
              "service_f7rqc6t",
              "template_mbhipw5",
              this.formData,
              "-zEI4YqttQNgREkFa"
          )
          .then(() => {
            this.submitted = true;
            this.emailError = false;
            this.isLoading = false;
          })
          .catch((error) => {
            console.error("Greška:", error);
            this.emailError = true;
            this.submitted = true;
            this.isLoading = false;
          });
    },

  },

  created() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/main.scss";

.statistics-section-mobile {
  gap: 20px !important;


  .background-image {
    width: 100%;
    height: 580px !important;
    object-fit: cover;
  }

  .content {
    font-family: 'Inter-Regular', 'Inter', sans-serif;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: $darker-blue;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 15px !important;
    width: 90% !important;

    .title {
      text-transform: uppercase;
      font-size: 30px !important;
      padding: 0px !important;
      font-weight: bold;
    }

    .description {
      text-align: center;
      font-size: 10px;
      color: #232438;

      p {
        font-size: 10px !important;
        margin: 0;
        line-height: 20px !important;
      }
    }

    .cards {
      gap: 10px !important;

      .single-card {
        font-size: 9px !important;
        padding: 10px !important;
        width: 100%;
        min-width: 150px !important;
        }

    }

    .btn {
      font-size: 12px !important;
      border-radius: 8px !important;
      padding: 12px !important;
      width: 200px !important;

      &:hover {
        background-color: rgba(35, 36, 56, 0.35);
        border: 1px solid $darker-blue;
      }
    }
  }
}

.statistics-section {
  width: 100%;
  background-color: white;

  .transfer {
    position: relative;
    overflow: hidden;
    // width: 500px; /* Postavi širinu roditelja */
    // height: 300px; /* Postavi visinu roditelja */
  }

  .background-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }


  .content {
    font-family: 'Inter-Regular', 'Inter', sans-serif;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: $darker-blue;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 50px;

    .title {
      text-transform: uppercase;
      font-size: 60px;
      font-weight: bold;
    }

    .description {
      text-align: center;
      font-size: 20px;
      color: #232438;

      p {
        line-height: 12px;
      }
    }

    .cards {
      display: flex;
      align-items: center;
      gap: 50px;

      .single-card {
        font-family: Inter, sans-serif;
        font-size: 18px;
        //text-transform: uppercase;
        background-color: #FFFFFF;
        font-weight: bold;
        padding: 50px;
        border-radius: 15px;
        border: 1px solid black;
        min-width: 290px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
     p {
       text-transform: uppercase;
       padding: 0 0 25px;
       margin: 0;
     }
      }

      &.animate {
        opacity: 1;

        .left {
          animation: slideInFromLeft 2s forwards;
        }

        .right {
          animation: slideInFromRight 2s forwards;
        }
      }

      @keyframes slideInFromLeft {
        0% {
          transform: translateX(-100%);
          opacity: 0;
        }
        100% {
          transform: translateX(0);
          opacity: 1;
        }
      }

      @keyframes slideInFromRight {
        0% {
          transform: translateX(100%);
          opacity: 0;
        }
        100% {
          transform: translateX(0);
          opacity: 1;
        }
      }
    }

    .btn {
      font-family: Inter, sans-serif;
      font-size: 23px;
      text-transform: uppercase;
      background-color: $primary-blue;
      color: white;
      font-weight: 600;
      border: 1px solid $primary-blue;
      border-radius: 15px;
      padding: 13px;
      max-width: 350px;
      width: 100%;
      transition: transform 0.3s ease-out, background-color 1s ease;

      &:hover {
        background-color: rgba(35, 36, 56, 0.35);
        border: 1px solid $darker-blue;
      }
    }
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  /* Centered Modal Box */
  .modal {
    background-color: rgba(35, 36, 56, 0.35);
    border: 1px solid $darker-blue;
    //  background-color:  rgb(85 172 173 / 30%);
    backdrop-filter: blur(30px);
    border-radius: 15px;
    //  border: 1px solid #9D9D9D;
    padding: 20px;
    width: 440px;
    color: #FFFFFF;
    text-align: center;
    position: relative;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
    animation: fadeIn 0.3s ease-in-out;
  }

  form {
    display: flex;
    flex-direction: column;

    .row {
      display: flex;
      align-items: center;
      width: 100%;
      gap: 10px;
    }
  }

  /* Close Button */
  .close-btn {
    background: none;
    border: none;
    font-size: 22px;
    position: absolute;
    right: 15px;
    top: 15px;
    cursor: pointer;
    color: #FFFFFF;
  }

  /* Form Styling */
  label {
    width: 50%;
    text-align: left;
  }

  input, textarea {
    padding: 8px;
    margin: 5px 0;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
    resize: none;
    width: 100%;
  }

  /* Submit Button */
  .submit-btn {
    background: $darker-blue;
    color: white;
    padding: 10px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    width: 100%;
    transition: transform 0.3s ease-out, background-color 1s ease;
    margin-top: 15px;
  }

  .submit-btn:hover {
    background: $primary-blue;
  }

  .confirmation {
    text-align: center;
    animation: fadeIn 0.3s ease-in-out;
  }

  .confirmation p {
    font-size: 16px;
    margin: 10px 0;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(5px);
  }

  .spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid $primary-blue;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }


}

</style>
